import Api from 'store/effects/core/api';
import { requestGetClientsListAction } from 'store/actions/clientsList';
import { requestPostSendInvite } from 'store/actions/app';
import {
  getAgentClientsList,
  getAgentClientsListWithAgents,
  postInviteUser,
} from 'api/clientsList';
import { getAgentInviteClientSendValues } from 'store/selectors/app';

import { getState } from 'store';

export const requestGetClientsListEffect = (cfg?, options: { silent?: boolean } = {}, cb?) => {
  const requestParams = { action: requestGetClientsListAction, method: getAgentClientsList };

  let sendRequest = Api.execBase(requestParams);
  if (options.silent) sendRequest = Api.execResult(requestParams);

  return sendRequest(cfg, options, cb);
};

export const requestGetClientsListWithAgentsEffect = (
  cfg?,
  options: { silent?: boolean } = {},
  cb?,
) => {
  const requestParams = {
    action: requestGetClientsListAction,
    method: getAgentClientsListWithAgents,
  };

  let sendRequest = Api.execBase(requestParams);
  if (options.silent) sendRequest = Api.execResult(requestParams);

  return sendRequest(cfg, options, cb);
};

export const handleSendClientInviteForm = ({ values }, cb) => {
  const sendRequest = Api.execBase({ action: requestPostSendInvite, method: postInviteUser });
  const state = getState();
  const sendValues = getAgentInviteClientSendValues(state, values);
  return sendRequest(sendValues, {}, cb);
};
